/**
 * GFM 표 정렬 (`:---:`, `---:`) 을 Tailwind text-align 클래스로 매핑.
 *
 * remark-gfm → mdast-util-to-hast 가 th/td 의 `properties.align` 에 'left'|'center'|'right' 를
 * 넣고 (rehype-sanitize defaultSchema 가 `align` 속성을 허용해 살아남는다), react-markdown 이
 * 그 hast node 를 커스텀 컴포넌트의 `node` prop 으로 전달한다. 커스텀 th/td 가 이 값을 읽지
 * 않으면 정렬 마커가 무시된다 (특히 th 의 하드코딩 text-left 가 align 속성을 덮어씀).
 *
 * 마커가 없으면 'left' — 정렬 미지정 표의 기존 동작을 그대로 유지.
 */
export function alignClass(node: unknown): string {
  const align = (node as { properties?: { align?: string } } | undefined)?.properties?.align;
  return align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';
}
